<div class="head_content" [lang]="PePo.currentLang == 'ar' ? 'ar' : 'en'">

  <h2 *ngIf="header_txt" [innerText]="header_txt"></h2>
  <h3 *ngIf="header_txt_Two" [innerText]="header_txt_Two"></h3>
  <p *ngIf="header_parag" [innerText]="header_parag"></p>
</div>
